<template>
  <!-- eslint-disable tailwindcss/no-custom-classname -->
  <div class="flex items-center justify-between">
    <div class="flex items-center gap-4">
      <IconSparkles class="text-[#AFC354]" size="24" />
      <h3 class="gradient-text heading-2">
        {{ i18n(translations.title) }}
      </h3>
    </div>
    <slot name="info" />
  </div>
  <p
    class="text-static-default-mid body-1 text-justify"
    :class="{
      'line-clamp-5 md:line-clamp-none': !showMoreOpen && renderShowMoreButton,
    }"
  >
    {{ text }}
  </p>

  <RevLink
    v-if="renderShowMoreButton"
    class="text-action-default-hi body-2-bold md:hidden"
    :underlined="true"
    @click="showMoreOpen = !showMoreOpen"
  >
    {{ i18n(showMoreOpen ? translations.showLess : translations.showMore) }}
  </RevLink>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevLink } from '@ds/components/Link'
import { IconSparkles } from '@ds/icons/IconSparkles'

import translations from './AIText.translations'

const i18n = useI18n()

const { text } = defineProps<{
  text: string
}>()

const showMoreOpen = ref(false)
const MIN_SHOW_MORE_WORDS = 40

const renderShowMoreButton = computed(() => {
  return text.length >= MIN_SHOW_MORE_WORDS
})
</script>

<style scoped>
.gradient-text {
  background: linear-gradient(to right, #afc354, #e7729e);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>
